export class SiteTextConstants {
    public static InstructorCourseListPage: string = 'InstructorCourseListPage';
    public static InstructorRosterListingPage: string = 'InstructorRosterListingPage';
    public static InstructorModifyStudentListPage: string = 'InstructorModifyStudentListPage';
    public static InstructorUploadGradePage: string = 'InstructorUploadGradePage';
}
